import React from 'react'

interface IProps {
  image: string
  text: string
}

const pageTitle = (props: IProps) => {
  const { image, text } = props
  return (
    <div className='pt-[5.5rem] lg:pt-24'>
      <section
        className='after:bg-jacarta-900/60 relative bg-cover bg-center bg-no-repeat py-32 after:absolute after:inset-0'
        style={{ backgroundImage: `url(${image})` }}
      >
        <div className='container relative z-10'>
          <h1 className='font-display text-center text-4xl font-medium text-white'>
            {text}
          </h1>
        </div>
        <div className='absolute bottom-0 left-0 right-0 top-0 h-full w-full overflow-hidden bg-gradient-to-r from-indigo-400 via-purple-400 to-pink-400 opacity-70'></div>
      </section>
    </div>
  )
}

export default pageTitle
